import React from 'react'
import ExpenseReport, {
  ExpenseReportContext,
} from 'src/app/ExpenseReport/ExpenseReport'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletReimbursementRouteProps } from 'src/navigation/routeProps'

const MyWalletReimbursementAppRoute: AppRoute = {
  id: AppLocation.MyWalletReimbursementDetail,
  routeProps: myWalletReimbursementRouteProps,
  component: <ExpenseReport context={ExpenseReportContext.myWallet} />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletReimbursementAppRoute
